import { useEffect } from "react";

const usePageLeave = (onLeave: () => void) => {
  const onBeforeUnload = (e: BeforeUnloadEvent) => {
    (e || window.event).returnValue = ""; // Gecko + IE

    onLeave();

    return ""; // Webkit, Safari, Chrome etc.
  };

  useEffect(() => {
    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);
};

export { usePageLeave };
